import PropTypes from "prop-types";
import { Grid, Container, Button } from "@mui/material";
import { NavLink } from "react-router-dom";

import StarringYouCards from "components/StarringYouCards";
import Placeholder from "components/Placeholder";

import { PlaceholderTitle, Root, Title } from "./styles";

const StarringYou = ({ items, loading, content }) => {
  const renderTitle = () => {
    if (loading)
      return (
        <PlaceholderTitle variant="h2">
          <Placeholder variant="text" height={50} />
        </PlaceholderTitle>
      );
    return (
      <Title variant="h2" align="center">
        {content?.sectionSubHeaderText}
      </Title>
    );
  };

  const renderButton = () => {
    const url = loading || !content?.viewMoreUrl ? "/" : content.viewMoreUrl;

    return (
      <Button id="home-video-ecards-view-more" component={NavLink} variant="outlined" color="primary" to={url}>
        {content?.viewMoreText}
      </Button>
    );
  };

  return (
    <Root>
      <Container>{renderTitle()}</Container>

      <StarringYouCards items={items} title={null} loading={loading} />

      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>{renderButton()}</Grid>
      </Grid>
    </Root>
  );
};

StarringYou.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      attributes: PropTypes.shape({}),
    }),
  ),
  loading: PropTypes.bool,
  content: PropTypes.shape({
    viewMoreText: PropTypes.string,
    sectionHeaderText: PropTypes.string,
    sectionSubHeaderText: PropTypes.string,
    viewMoreUrl: PropTypes.string,
  }),
};

export default StarringYou;
